export default function PermissionLoadingSkeleton() {
  return (
    <div className="permission-skeleton" aria-label="Loading permissions">
      <div className="permission-skeleton-header" />
      <div className="permission-skeleton-line wide" />
      <div className="permission-skeleton-line" />
      <div className="permission-skeleton-line short" />
    </div>
  );
}
